import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-providers-settings',
  templateUrl: './service-providers-settings.component.html',
  styleUrls: ['./service-providers-settings.component.scss']
})
export class ServiceProvidersSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
